export var RequestStatus;
(function (RequestStatus) {
    /** Undefined request status. */
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Pending group request. */
    RequestStatus["PENDING"] = "PENDING";
    /** Approved group request. */
    RequestStatus["APPROVED"] = "APPROVED";
    /** Rejected group request. */
    RequestStatus["REJECTED"] = "REJECTED";
    /** *Deprecated. Use `CANCELED`.** Cancelled group request. */
    RequestStatus["CANCELLED"] = "CANCELLED";
    /** Canceled group request. */
    RequestStatus["CANCELED"] = "CANCELED";
})(RequestStatus || (RequestStatus = {}));
export var ViolationType;
(function (ViolationType) {
    ViolationType["NONE"] = "NONE";
    ViolationType["NOT_LOGGED_IN"] = "NOT_LOGGED_IN";
    ViolationType["ALREADY_JOINED"] = "ALREADY_JOINED";
    ViolationType["SECRET_GROUP"] = "SECRET_GROUP";
    ViolationType["EVENTS"] = "EVENTS";
    ViolationType["PRICING_PlANS"] = "PRICING_PlANS";
    ViolationType["MEMBERSHIP_QUESTIONS"] = "MEMBERSHIP_QUESTIONS";
    ViolationType["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
})(ViolationType || (ViolationType = {}));
export var ItemsToUpdate;
(function (ItemsToUpdate) {
    /** Take into account only items which are listed in the request. */
    ItemsToUpdate["BY_ID"] = "BY_ID";
    /** Update all items. */
    ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsToUpdate || (ItemsToUpdate = {}));
export var OwnershipFilter;
(function (OwnershipFilter) {
    /** All items. */
    OwnershipFilter["ALL"] = "ALL";
    /** Items for the current site member. */
    OwnershipFilter["CURRENT_MEMBER"] = "CURRENT_MEMBER";
})(OwnershipFilter || (OwnershipFilter = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map